import React from 'react';
import moment from 'moment';

import http from 'api/http';

import { downloadFile } from 'helpers';

import NotificationManager from 'dom-managers/notification';

export default function FileRow({file, index, handleRemoveFile, httpParams, isEditable, doNotRemoveFiles}) {
  const handleDownloadFile = () => {
    http.get(httpParams.currentMethod(httpParams.currentId, file[httpParams.fileIdFieldName || 'id']), {
      responseType: 'blob'
    })
      .then(({data}) => {
        downloadFile(data, file.name);
      });
  };

  const fileIsNotExist = file.hasOwnProperty('exists') && file.exists === false;

  return (
    <div className='ect-file-picker__files-row'>
      <div className='ect-file-picker__col_name ect-file-picker__col_name_icon'>{file.name}</div>
      {file.created &&
      <div className='ect-file-picker__col_upload-date'>{moment(file.created).format('MM/DD/YYYY')}</div>}
      {file.created && <div className='ect-file-picker__col_download'>
        {fileIsNotExist ? (
          <div
            className='_download-attention-icon'
            onClick={() => NotificationManager.error(1, 'Uploaded file no longer exists on server.')}
          />
        ) : (
          <div className='_download-icon' onClick={handleDownloadFile} />
        )}
      </div>}
      {(isEditable && !doNotRemoveFiles) && <div className='ect-file-picker__col_remove'>
        <div className='__remove-icon' onClick={handleRemoveFile(index)} />
      </div>}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/app/Components/FilePicker/FileRow.jsx